
import { observer } from 'mobx-react-lite';
//
import { SectionTab } from 'polotno/side-panel';
import { ImagesGrid } from 'polotno/side-panel/images-grid';
// import our own icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { faCrop, faCropAlt, faExpandArrowsAlt } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { Button } from '@mui/material';
export const SizePanel = observer(({ store }) => {
    const [images, setImages] = useState([]);
    const listSize = [
        {
            icon: faFacebook,
            name: "Facebook Post",
            width: 1080,
            height: 1080
        },
        // {
        //     icon: faInstagram,
        //     name: "Instagram Post",
        //     width: 1080,
        //     height: 1080
        // },
        // {
        //     icon: faFacebook,
        //     name: "Facebook Cover",
        //     width: 815,
        //     height: 315
        // },
        // {
        //     icon: faInstagram,
        //     name: "Instagram Story",
        //     width: 1080,
        //     height: 1920
        // },
    ]
    return (
        <div style={{ height: '100%', }}>
            <h4 style={{ marginBottom: "1em", marginLeft: '2px' }}>
                Change card size
            </h4>
            {listSize.map(item =>
                <Button variant="contained" key={item.name} onClick={() => { store.setSize(item.width, item.height); }} style={{ width: "100%", display: "block", marginTop: "1em" }}>
                    <div>
                        <FontAwesomeIcon icon={item.icon} style={{ marginRight: "5px" }} />
                        <span>{item.name + " "}</span>
                    </div>
                </Button>
            )}
        </div>
    );
});
// define the new custom section
export const CustomSize = {
    name: 'Size',
    Tab: (props) => (
        <SectionTab name="Size" {...props}>
            <FontAwesomeIcon icon={faExpandArrowsAlt} />
        </SectionTab>
    ),
    Panel: SizePanel,
};